import React, { useRef, useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch } from "react-redux";
import { assetsActions } from "../../../../store/assetsManagement/assetsActions";
import CloseIcon from "@material-ui/icons/Close";

const CollectionCategoryPopup = ({
  closePopup,
  openPopup,
  startLoading,
  endLoading,
  loadData,
  isEdit,
  editData,
}) => {
  const dispatch = useDispatch();
  const [categoryName, setCategoryName] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    startLoading();
    if (isEdit) {
      dispatch(
        assetsActions.onUpdateColCategory(categoryName, editData.id)
      ).then((data) => {
        closePopup();
        loadData();
      });
    } else {
      dispatch(assetsActions.onAddColCategory(categoryName)).then((data) => {
        closePopup();
        loadData();
      });
    }
  };

  useEffect(() => {
    if (isEdit) {
      setCategoryName(editData.name);
    }
  }, []);

  return (
    <div>
      <Dialog
        open={openPopup}
        onClose={closePopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <ValidatorForm ref={useRef("form")} onSubmit={handleSubmit}>
          <DialogTitle id="alert-dialog-title">
            {isEdit ? "Update Collection Category" : "Add Collection Category"}
            <CloseIcon className="closePopup" onClick={closePopup} />
          </DialogTitle>
          <DialogContent className="addLaunchPopupWrapper">
            <DialogContentText id="alert-dialog-description">
              <TextValidator
                id="categoryName"
                label="Enter category name"
                variant="outlined"
                name="categoryName"
                fullWidth
                validators={["required"]}
                errorMessages={["Field is required"]}
                value={categoryName}
                onChange={(v) => setCategoryName(v.target.value)}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions className="popupFooter addCatFooter">
            <Button color="primary" variant="contained" autoFocus type="submit">
              {isEdit ? "Update" : "Add"}
            </Button>
          </DialogActions>
        </ValidatorForm>
      </Dialog>
    </div>
  );
};

export default CollectionCategoryPopup;
